import React, { memo } from 'react';
import { Box, Checkbox, styled } from '@mui/material';
import { OfficialGrade } from 'routes/HumanResourcesModule/Settings/HrGrade/helpers/type';
import Flex from 'ui/Flex/Flex';
import { TreeItem } from '@mui/x-tree-view';

export const StyTreeItem = styled(TreeItem, {
    name: 'StyTreeItem',
})({
    '.MuiTreeItem-content': {
        '&.Mui-focused, &.Mui-selected, :hover': {
            backgroundColor: 'transparent',
        },
    },
});

const StyBoxLabel = styled(Box, {
    name: 'StyBoxLabel',
})(() => ({
    alignSelf: 'center',
    padding: '2% 1%',
    flexBasis: '100%',
    '&:hover': {
        backgroundColor: 'rgba(0,0,0,0.04)',
    },
}));
type Props = {
    officialGrade: OfficialGrade;
    checked: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

function OfficialGradeItem({ officialGrade, checked, onChange }: Props) {
    return (
        <StyTreeItem
            nodeId={`grade-${officialGrade.grade}`}
            label={
                <Flex>
                    <Checkbox
                        id={officialGrade.grade}
                        checked={checked}
                        onChange={onChange}
                    />
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    >
                        <StyBoxLabel
                            onClick={(event) => event.stopPropagation()}
                        >
                            {officialGrade.grade}
                        </StyBoxLabel>
                    </Box>
                </Flex>
            }
            key={officialGrade.id}
        />
    );
}

export default memo(OfficialGradeItem);
